export default __webpack_public_path__ + "static/media/GNT.aa907dbd.png";